import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "disease-item"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-long-arrow-left mr-2" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Tất cả dịch bệnh ")
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 0,
  class: "mt-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_CommentItem = _resolveComponent("CommentItem")!
  const _component_DiseaseItem = _resolveComponent("DiseaseItem")!

  return (_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Loading, { loading: _ctx.loading }, null, 8, ["loading"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args))),
          class: "back-link mb-2"
        }, _hoisted_5),
        _createVNode(_component_DiseaseItem, {
          diseaseSituation: _ctx.diseaseComments[0].situation
        }, {
          default: _withCtx(() => [
            (_ctx.diseaseComments && _ctx.diseaseComments.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.diseaseComments, (item) => {
                    return (_openBlock(), _createBlock(_component_CommentItem, {
                      comment: item,
                      key: item.id
                    }, null, 8, ["comment"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["diseaseSituation"])
      ]))
}